<template>
    <div :class="'flex-task-item task-box-alt '+(task.country_id === 'XX' ? 'master' : 'country'+task.country_id) +' '+(task.is_overwritten ? 'task-overwritten' : '')">
        <button type="button"
                :class="'task-btn '+(task.is_overwritten ? 'btn-default' : (task.completed_at ? 'btn-success' : (task.started_at ? 'btn-primary' : 'btn-warning')))"
                data-toggle="modal"
                data-target="#taskModal"
                :data-task="JSON.stringify(task)"
        >
           {{task.shortTitle}}
            <span v-if="!task.is_relevant && !task.is_overwritten && !task.completed_at && !task.started_at">
                <i v-if="!task.is_relevant_by_combination" class="fa fa-sitemap text-danger"></i>
                <i v-if="!task.is_relevant_by_country" class="fa fa-flag text-danger"></i>
                <i v-if="!task.is_relevant_by_language" class="fa fa-comment text-danger"></i>
            </span>
            <span v-if="task.is_blocked_by_predecessor && !task.is_overwritten && !task.completed_at">
                <i class="fa fa-step-backward text-danger"></i>
            </span>
        </button>
    </div>
</template>

<script>
    export default {
        props: [
            'taskJson',
        ],

        computed: {
            task() {
                return JSON.parse(this.taskJson);
            }
        },
    };
</script>